import { Component } from 'react';
import React from 'react';
import {
  Button,
  Card,
  CardBody,
  CardTitle,
  CardText,
  ListGroup,
  ListGroupItem,
  ModalHeader,
  ModalBody, Table, ModalFooter, Modal
} from 'reactstrap';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import api from '../api/dataSource';
import moment from 'moment';
import { Loading } from './Loading';

const MySwal = withReactContent(Swal)

function CardAgente({agentes, mostrarAsociado}){
  let getDataAsociado = (asociado) => {
    //let uri = `CD2/Asociados/ObtenerKardexAsociado?AsociadoID=${asociado.id}&jwt_off=1`;
    let uri = `CD2/Asociados/ObtenerAsociadoPagina?AsociadoID=${asociado.id}&jwt_off=1`;
    MySwal.showLoading();
    MySwal.disableButtons();
    api.get(uri).then(data => {
      mostrarAsociado({data});
      /*api.get(uriDocumentos).then(dataDoc => {
        mostrarAgencia({data,dataDoc});
      }).catch(error => {
        console.log(error);
      });*/
    }).catch(error => {
      console.log(error);
    }).finally(()=> {
      MySwal.close()
    });
  }

  return agentes.map((agente) => {
    let imagen;
    if(agente.img){
      imagen = <img className=" img-fluid" src={`http://demo.crdascz.com:64760/api/SYS/SHARED/ReturnFileArchivo?FileArchivo=${agente.img}&jwt_off=1`} alt="card image"/>;
    }else{
      imagen = "";
    }

    let laFecha = moment(agente.fechaNacimiento).format('DD/MM/YYYY');
    return (
      <div className="col-md-4">
        <div className="card-agencia rowx" onClick={ () => getDataAsociado(agente) }>
          <div style={{flex: '70%'}}>
            <h6><strong>{agente.name}</strong></h6>
            <p className="comprimido"><small>{agente.agencia}</small></p>
          </div>
          <div style={{flex: '30%'}}>
            <img className="img-fluid" src={agente.imagen} alt="card image"/>
          </div>
        </div>
      </div>
    )
  });
}

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      agentes: [],
      agentesFilter: [],
      filtro: '',
      asociado: {
        AgenciaActual: '',
        FechaRegistro: '',
        EstadoActual: '',
        Licencia: '',
        Matricula: '',
        ModalidadActual: '',
      },
      agencia: {
        Email1 : '',
        TelefonoFijo: ''
      },
      titulo: '',
      foto: '',
      logo: '',
      modalShow: false,
      loading:false
    };

    this.getData = this.getData.bind(this);
    this.filterData = this.filterData.bind(this);
    this.openModal = this.openModal.bind(this);
    this.cerrarModal = this.cerrarModal.bind(this);
  }

  getData(){
    this.setState({ loading: true });
    let uri = 'CD2/Asociados/ListarAsociadoSimpleMultimedia?jwt_off=1';
    api.get(uri).then(data => {
      let eldata = [];
      data.forEach((item, i) => {
        let p = item.PersonaPERpersona;

        let doc = item.Documento;
        let imagen = "";
        if(!!doc){
          if(doc.NavCD2documentoAsociadoMultimedias.length > 0){
            imagen = `https://crdascz.siga.com.bo/api/SYS/SHARED/ReturnFileArchivo?FileArchivo=${doc.NavCD2documentoAsociadoMultimedias[0].FileArchivo}&jwt_off=1`;
          }else{
            imagen = "http://crdascz.com/CRDASCZ/wp-content/uploads/2021/01/sinfoto.jpg";
          }
        }else{
          imagen = "http://crdascz.com/CRDASCZ/wp-content/uploads/2021/01/sinfoto.jpg";
        }

        if(item.EstadoCD2estadoAsociadoID==='Activo'){
          eldata.push({
            id: item.CD2asociadoID,
            imagen,
            name:  `${p.ApellidoPaterno} ${p.ApellidoMaterno}, ${p.Nombre}`,
            carnet: p.CarnetIdentidad,
            fechaNacimiento: p.FechaNacimiento,
            status: item.EstadoCD2estadoAsociadoID,
            agencia: item.AgenciaActual
          })
        }
        if(item.EstadoCD2estadoAsociadoID === "Activo" && !!item.AgenciaActualID && !!item.multimedia){
          eldata.push({
            img: item.imagen,
            name:  `${p.ApellidoPaterno} ${p.ApellidoMaterno}, ${p.Nombre}`,
            carnet: p.CarnetIdentidad,
            fechaNacimiento: p.FechaNacimiento,
            status: item.EstadoCD2estadoAsociadoID,
            agencia: item.AgenciaActual,
            agenciaId: item.AgenciaActualID
          });
        }
      });
      this.setState({
        agentes: eldata,
        agentesFilter: eldata,
        loading: false
      });
    }).catch(error => {
      this.setState({ loading: false });
      console.log(error);
    });
    /*let uriagencia = "CD2/Agencias/ListarAgenciaSimpleMultimedia?jwt_off=1"
    api.get(uriagencia).then(data => {
      console.log(data);
    }).catch(error => {
      console.log(error);
    });*/
    /*let dat = {
      "filter": "",
      "pagination": {
        "page": 1,
        "rowsNumber": 10,
        "rowsPerPage": 10,
        "sortBy": "",
        "descending": true
      }
    }
    fetch(uri2, {
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(dat) // body data type must match "Content-Type" header
    }).then(response => response.json()).then(data=> {
      console.log(data);
    });*/

  }

  componentDidMount(){
    this.getData();
  }

  filterData(valor){
    const filtrado = this.state.agentes.filter(e => e.name.toLowerCase().includes(valor.toLowerCase()));
    if(!filtrado){
      filtrado=this.state.agentes;
    }
    this.setState({ filtro:valor, agentesFilter: filtrado })
  }

  openModal = (datos) => {
    let d = datos.data;
    let doc = d.Item2;
    let age = d.Item3;
    let agencia = d.Item4;
    let foto = "";
    if(doc.length !== 0){
      let f = doc.find(x=>x.TipoDocCD2tipoDocumentoAsociadoID === 'FOT');
      if(!!f){
        let ff = f.NavCD2documentoAsociadoMultimedias[0];
        foto = ff.FileArchivo;
      }
    }
    let logo = "";
    if(!!age){
      logo  = age.FileArchivo;
    }
    let persona = d.Item1.PersonaPERpersona;
    let titulo = `${persona.ApellidoPaterno} ${persona.ApellidoMaterno}, ${persona.Nombre}`;
    this.setState({
      modalShow: true,
      asociado: d.Item1,
      titulo,
      foto,
      logo,
      agencia
    });
  }

  cerrarModal = () => {
    this.setState({
      modalShow: false
    });
  }

  render(){
    //let base = "https://crdascz.siga.com.bo/api/";
    let imagen;
    let logo;
    if(this.state.foto !== ""){
      imagen = <img className=" img-fluid" src={`${api.baseUrl}SYS/SHARED/ReturnFileArchivo?FileArchivo=${this.state.foto}&jwt_off=1`} alt="card image"/>;
    }else{
      imagen = <img className=" img-fluid" src="http://crdascz.com/CRDASCZ/wp-content/uploads/2021/01/sinfoto.jpg" alt="card image"/>;
    }

    if(!!this.state.logo){
      logo = <img className=" img-fluid" src={`${api.baseUrl}SYS/SHARED/ReturnFileArchivo?FileArchivo=${this.state.logo}&jwt_off=1`} alt="card image"/>;
    }else{
      logo = "";
    }

    return (
      <div className="container" style={{paddingTop: '100px'}}>
        <div className="row">
          <div className="col-12">
            <Card>
                <CardBody className="text-center mt-4">
                    <CardTitle>
                      <img src="/img/lista.png"/>
                      <h1>Lista de Asociados</h1>
                    </CardTitle>
                    <CardText>
                      <div className="input-group mb-3">
                          <div className="input-group-prepend">
                            <img src="/img/search.png" className="icon-image"/>
                          </div>
                          <input type="text" value={ this.filtro } className="form-control input-lg" onChange={e => this.filterData(e.target.value)}/>
                      </div>
                    </CardText>
                </CardBody>
            </Card>
          </div>
        </div>
        <div className="row">
          <br/>
          {
            this.state.loading ?
              <Loading></Loading> :
              <CardAgente agentes={this.state.agentesFilter} mostrarAsociado={(data) => this.openModal(data)}></CardAgente>
          }
        </div>

        <Modal isOpen={this.state.modalShow} size="lg">
          <ModalHeader className="cardHeader" toggle={this.cerrarModal}>{this.state.titulo}</ModalHeader>
          <ModalBody className="imagenBackground">
            <div className="row">
              <div className="col-sm-12 col-md-9">
                <Card body>
                  <Table hover size="sm" bordered>
                    <tbody>
                    {
                      !!this.state.asociado.EstadoActual ?
                      <tr>
                        <th scope="row">
                          <i className="fa fa-address-book"></i>{' '}
                          Estado
                        </th>
                        <td>{this.state.asociado.EstadoActual}</td>
                      </tr>
                      : ""
                    }
                    {
                      !!this.state.asociado.FechaRegistro ?
                      <tr>
                        <th scope="row">
                          <i className="fa fa-calendar-o"></i>{' '}
                          Fecha de Registro
                        </th>
                        <td>{this.state.asociado.FechaRegistro.slice(0,10)}</td>
                      </tr>
                      : ""
                    }
                    {
                      !!this.state.asociado.ModalidadActual ?
                      <tr>
                        <th scope="row">
                          <i className="fa fa-file-archive-o"></i>{' '}
                          Modalidad
                        </th>
                        <td>{this.state.asociado.ModalidadActual}</td>
                      </tr>
                      : ""
                    }
                    {
                      !!this.state.asociado.Licencia ?
                      <tr>
                        <th scope="row">
                          <i className="fa fa-address-card"></i>{' '}
                          N° Licencia despachante de Aduana
                        </th>
                        <td>{this.state.asociado.Licencia}</td>
                      </tr>
                      : ""
                    }
                    {
                      !!this.state.asociado.Matricula ?
                      <tr>
                        <th scope="row">
                          <i className="fa fa-id-card-o"></i>{' '}
                          Matricula CNDA
                        </th>
                        <td>{this.state.asociado.Matricula}</td>
                      </tr>
                      : ""
                    }
                    {
                      !!this.state.asociado.PersonaPERpersona && !!this.state.asociado.PersonaPERpersona.Email ?
                      <tr>
                        <th scope="row" width="40%">
                          <i className="fa fa-h-square"></i>{' '}
                          Email
                        </th>
                        <td>{this.state.asociado.PersonaPERpersona.Email}</td>
                      </tr>
                      : ""
                    }
                    {
                      !!this.state.asociado.AgenciaActual ?
                      <tr>
                        <th scope="row">
                          <i className="fa fa-h-square"></i>{' '}
                          Agencia Actual
                        </th>
                        <td>{this.state.asociado.AgenciaActual}</td>
                      </tr>
                      : ""
                    }
                    {
                      !!this.state.agencia && !!this.state.agencia.TelefonoFijo ?
                      <tr>
                        <th scope="row">
                          <i className="fa fa-h-square"></i>{' '}
                          Telefono Agencia
                        </th>
                        <td>{this.state.agencia.TelefonoFijo}</td>
                      </tr>
                      : ""
                    }
                    </tbody>
                  </Table>
                </Card>
              </div>
              <div className="col-sm-12 col-md-3">
                <Card body>
                  {imagen}
                </Card>
                <br></br>
                <Card body>
                  {logo}
                </Card>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default Main;